<template>
  <div v-loading.fullscreen.lock='loading'>
    <el-row>
      <el-col :span="24">
        <el-button
          style=" padding:0; margin:20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回1
          </el-button>
      </el-col>
    </el-row>

    <el-form
      ref="form"
      :model="data"
      label-width="120px"
      size="small"
    >
      <el-row>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-form-item label="列表">
              {{data.topic_list}}
            </el-form-item>
            <el-form-item label="标题">
              {{data.original.title}} 【{{data.choice == 1 ? '普通动态' : '精选动态'}}】
            </el-form-item>
            <el-form-item label="内容">
              {{data.original.content}}
            </el-form-item>
            <el-form-item label="数据">
              阅读：{{data.views}} 点赞：{{data.likes}} 回复：{{data.replies}}
              <el-button type="text" size="small" @click="toReplies(id)">
                查看回复
              </el-button>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content bg-purple-light">
            <el-form-item label="用户信息">
              <div>
                <img
                  :src="data.avatar"
                  width="100px"
                  alt=""
                >
              </div>
              <div>{{data.nickname}}</div>
              <div>{{data.mobile_phone}}</div>
            </el-form-item>
            <el-form-item label="动态图片">
              <div>
                <img
                  v-for="(item, index) in data.res_list"
                  :key='index'
                  :src="item.res_url"
                  width="100px;"
                  style="width:100px;height:100px;margin:10px;"
                  preview="1"
                  preview-text=""
                  alt=""
                >
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      </el-form>
  </div>
</template>

<script>
import { getMomentInfo } from "@/api/moment";

export default {
  data() {
    return {
      loading: false,
      id: "",
      data: {
        original: { title: "", content: "" },
        res_list: []
      }
    };
  },
  created: function() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    toReplies(id) {
      this.$router.push({
        path: '/moment/replies_list',
        query: {
          id: id,
        }
      })
    },
    getInfo() {
      this.loading = true;
      getMomentInfo({
        moment_id: this.id
      }).then(response => {
        this.data = response.data;
        this.loading = false;
        this.$previewRefresh()
      });
    }
  }
};
</script>
